"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { RxChevronRight } from "react-icons/rx";
/*import { backgroundImage } from "../../assets/images/services.jpg";*/


export function Explore() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 bg-[#001E34] text-white h-40dvh ">
      <div className="container md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="flex flex-col">
          <div className="rb-12 mb-12 md:mb-18 lg:mb-20">
            <div className="w-full max-w-7xl">
              <p className="mb-3 font-semibold md:mb-4">Services</p>
              <h2 className="font-noto text-4xl leading-14 md:max-w-4xl">
              Entdecken Sie unsere umfassenden Sicherheitslösungen              </h2>
              <p className="max-w-xl md:text-md mt-4">
              In der heutigen digitalen Welt sind Unternehmen ständig neuen Cyberbedrohungen ausgesetzt. Unsere spezialisierten Dienstleistungen helfen Ihnen, diesen Herausforderungen proaktiv zu begegnen und Ihre digitalen Assets zu schützen.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 items-start justify-center gap-y-10 md:grid-cols-2 md:gap-x-8 md:gap-y-16 lg:gap-x-12 max-w-7xl">
            <div className="flex w-full flex-col">
              <div className="mb-5 md:mb-6">
                <img
                  src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                  className="size-12 invert"
                  alt="Relume logo"
                />
              </div>
              <h3 className="mb-5 text-xl md:mb-6 md:text-2xl md:leading-[1.3] lg:text-3xl">
              Sicherheitsbewertung & Risikoanalyse              </h3>
              <p className="mt-2 max-w-lg w-full text-lg">Wir identifizieren Schwachstellen in Ihren Systemen und bieten detaillierte Analysen, um Risiken zu minimieren.</p>
            </div>
            <div className="flex w-full flex-col">
              <div className="mb-5 md:mb-6">
                <img
                  src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                  className="size-12 invert"
                  alt="Relume logo"
                /> 
              </div>
              <h3 className="mb-5 text-xl md:mb-6 md:text-2xl md:leading-[1.3] lg:text-3xl">
              Kontinuierliches Sicherheitsmonitoring
              </h3>
              <p className="mt-2 max-w-lg w-full text-lg">Unser 24/7 Monitoring stellt sicher, dass Bedrohungen frühzeitig erkannt und neutralisiert werden.</p>
            </div>
            <div className="flex w-full flex-col">
              <div className="mb-5 md:mb-6">
                <img
                  src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                  className="size-12 invert"
                  alt="Relume logo"
                />
              </div>
              <h3 className="mb-5 text-xl md:mb-6 md:text-2xl md:leading-[1.3] lg:text-3xl">
              Schulung & Sensibilisierung
              </h3>
              <p className="mt-2 max-w-lg w-full text-lg">Durch gezielte Trainings erhöhen wir das Sicherheitsbewusstsein Ihrer Mitarbeiter und stärken die menschliche Firewall Ihres Unternehmens.</p>
            </div>
            <div className="flex w-full flex-col">
              <div className="mb-5 md:mb-6">
                <img
                  src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                  className="size-12 invert"
                  alt="Relume logo"
                /> 
              </div>
              <h3 className="mb-5 text-xl md:mb-6 md:text-2xl md:leading-[1.3] lg:text-3xl">
              Notfallreaktion & Vorfallsmanagement              </h3>
              <p className="mt-2 max-w-lg w-full text-lg">Unser 24/7 Monitoring stellt sicher, dass Bedrohungen frühzeitig erkannt und neutralisiert werden.</p>
            </div>
          </div>
          <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
           
          </div>
        </div>
      </div>
    </section>
  );
}
